import { render, staticRenderFns } from "./CellRendererCreatedOnReg.vue?vue&type=template&id=797538a8&"
import script from "./CellRendererCreatedOnReg.vue?vue&type=script&lang=js&"
export * from "./CellRendererCreatedOnReg.vue?vue&type=script&lang=js&"
import style0 from "./CellRendererCreatedOnReg.vue?vue&type=style&index=0&id=797538a8&prod&lang=scss&scpoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports